import { useState } from 'react';

const CalculatorSection = () => {
  const [annualCollection, setAnnualCollection] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');

  const calculateSavings = () => {
    const collection = parseFloat(annualCollection) || 0;
    const annualSaving = collection * 0.05; // 5% savings
    const salaryExpense = collection * 0.07; // 7%
    const overheadExpense = collection * 0.03; // 3%
    const inHouseCost = collection * 0.10; // 10%

    return {
      annualSaving: annualSaving.toFixed(2),
      salaryExpense: salaryExpense.toFixed(2),
      overheadExpense: overheadExpense.toFixed(2),
      inHouseCost: inHouseCost.toFixed(2)
    };
  };

  const savings = calculateSavings();

  return (
    <section className="bg-white py-10">
      <div className="max-w-[1330px] mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Section Heading */}
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold mb-4">
            <span className="text-blue-500">Secure Your Practice Revenue</span>{' '}
            <span className="text-gray-900">with Outsourced Billing</span>
          </h2>
          <p className="text-gray-600 text-base lg:text-lg max-w-4xl mx-auto">
            You can properly calculate and increase your revenue by outsourcing your medical billing to our healthcare professionals. 
            We improve cash flow and payment precision while reducing operations cost. This allows you to concentrate on patient care, 
            while we safely and consistently handle your revenue.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 items-start">
          
          {/* Left Side - Calculator Form */}
          <div className="bg-gray-50 rounded-3xl p-8 lg:p-10">
            <h3 className="text-3xl font-bold text-gray-900 mb-8">Billing Savings Calculator</h3>
            
            <div className="space-y-6">
              {/* Annual Collection Input */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Annual Collection ($)
                </label>
                <input
                  type="number"
                  value={annualCollection}
                  onChange={(e) => setAnnualCollection(e.target.value)}
                  placeholder="1.34"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                />
              </div>

              {/* Name Input */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Name
                </label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Enter your name"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                />
              </div>

              {/* Email Input */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Email
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                />
              </div>

              {/* Phone Input */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Phone
                </label>
                <input
                  type="tel"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  placeholder="Enter your phone number"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                />
              </div>

              {/* Submit Button */}
              <button className="w-full bg-blue-800 hover:bg-blue-700 text-white font-bold py-4 rounded-lg transition-colors shadow-lg">
                Estimate Revenu Loss
              </button>
            </div>
          </div>

          {/* Right Side - Savings Display */}
          <div className="rounded-3xl overflow-hidden h-full">
            <img 
              src="/calculator1.jpg" 
              alt="Calculator" 
              className="w-full h-full object-cover"
            />
          </div>

        </div>
      </div>
    </section>
  );
};

export default CalculatorSection;
